import React, { useState } from 'react';
import { FaTrash, FaEdit } from 'react-icons/fa';
import pb from '../../../services/pocketbase';
import Modal from '../../Modal/Modal';
import './AttributeManager.css';

function AttributeManager({ title, collectionName, items, onUpdate }) {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [newItemName, setNewItemName] = useState('');
  const [updatedItemName, setUpdatedItemName] = useState('');

  // --- Handlers for ADD modal ---
  const handleAddItem = async (e) => {
    e.preventDefault();
    if (!newItemName.trim()) {
      alert('Le nom ne peut pas être vide.');
      return;
    }
    try {
      await pb.collection(collectionName).create({ name: newItemName });
      alert(`${title} ajouté avec succès !`);
      setNewItemName('');
      setIsAddModalOpen(false);
      onUpdate();
    } catch (error) {
      console.error(`Erreur lors de l'ajout de ${collectionName}:`, error);
      alert(`Erreur: ${error.message}`);
    }
  };

  // --- Handlers for EDIT modal ---
  const handleEditClick = (item) => {
    setItemToEdit(item);
    setUpdatedItemName(item.name);
    setIsEditModalOpen(true);
  };

  const handleUpdateItem = async (e) => {
    e.preventDefault();
    if (!updatedItemName.trim()) {
      alert('Le nom ne peut pas être vide.');
      return;
    }
    if (!itemToEdit) return;
    try {
      await pb.collection(collectionName).update(itemToEdit.id, { name: updatedItemName });
      alert('Élément mis à jour avec succès !');
      setIsEditModalOpen(false);
      setItemToEdit(null);
      onUpdate();
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de ${collectionName}:`, error);
      alert(`Erreur: ${error.message}`);
    }
  };

  // --- Handler for DELETE action ---
  const handleDeleteItem = async (itemId) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet élément ?')) {
      try {
        await pb.collection(collectionName).delete(itemId);
        alert('Élément supprimé avec succès !');
        onUpdate();
      } catch (error) {
        console.error(`Erreur lors de la suppression de ${collectionName}:`, error);
        alert(`Erreur: ${error.message}`);
      }
    }
  };

  return (
    <div className="attribute-manager-container">
      <div className="list-header">
        <h4>{title}</h4>
        <button onClick={() => setIsAddModalOpen(true)}>Ajouter un nouvel élément</button>
      </div>
      <div className="dashboard-table-container">
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items && items.length > 0 ? (
              items.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>
                    <div className="item-actions">
                      <button onClick={() => handleEditClick(item)} className="edit-btn" title="Modifier"><FaEdit /></button>
                      <button onClick={() => handleDeleteItem(item.id)} className='delete-btn' title="Supprimer"><FaTrash /></button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2">Aucun élément trouvé.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add Modal */}
      {isAddModalOpen && (
        <Modal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} title={`Ajouter : ${title}`}>
          <form onSubmit={handleAddItem} className="dashboard-form">
            <input
              type="text"
              value={newItemName}
              onChange={(e) => setNewItemName(e.target.value)}
              placeholder="Nom du nouvel élément"
              autoFocus
            />
            <div className="modal-actions">
              <button type="submit" className="add-btn">Ajouter</button>
              <button type="button" onClick={() => setIsAddModalOpen(false)} className="cancel-btn">Annuler</button>
            </div>
          </form>
        </Modal>
      )}

      {/* Edit Modal */}
      {isEditModalOpen && itemToEdit && (
        <Modal isOpen={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} title={`Modifier : ${itemToEdit.name}`}>
          <form onSubmit={handleUpdateItem} className="dashboard-form">
            <input
              type="text"
              value={updatedItemName}
              onChange={(e) => setUpdatedItemName(e.target.value)}
              autoFocus
            />
            <div className="modal-actions">
              <button type="submit" className="add-btn">Mettre à jour</button>
              <button type="button" onClick={() => setIsEditModalOpen(false)} className="cancel-btn">Annuler</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
};

export default AttributeManager;
